import { isMobile } from 'react-device-detect'

const audios = {
  'XIAO QUAN': { // Box
    hover: new Audio('/assets/sounds/SFX/mo_cubo.wav'),
    click: new Audio('/assets/sounds/SFX/c_cubo.wav'),
  },
  Podeserdesligado: { // Sphere
    hover: new Audio('/assets/sounds/SFX/mo_esfera.wav'),
    click: new Audio('/assets/sounds/SFX/c_esfera.wav'),
  },
  Mexa: { // TorusKnot
    hover: new Audio('/assets/sounds/SFX/mo_torusknot.wav'),
    click: new Audio('/assets/sounds/SFX/c_torusknot.wav'),
  },
  'Miss Tacacá': { // Torus
    hover: new Audio('/assets/sounds/SFX/mo_torus.wav'),
    click: new Audio('/assets/sounds/SFX/c_torus.wav'),
  },
  Diaz: { // Cone
    hover: new Audio('/assets/sounds/SFX/mo_piramide.wav'),
    click: new Audio('/assets/sounds/SFX/c_piramide.wav'),
  },
  'ótimoKaráter': { // Dodecahedron
    hover: new Audio('/assets/sounds/SFX/mo_dodecaedro.wav'),
    click: new Audio('/assets/sounds/SFX/c_dodecaedro.wav'),
  },
  Menu: {
    hover: new Audio('/assets/sounds/SFX/mo_genesys.wav'),
    click: new Audio('/assets/sounds/SFX/c_genesys.wav'),
  },
  Info: {
    hover: new Audio('/assets/sounds/SFX/mo_info.wav'),
    click: new Audio('/assets/sounds/SFX/c_info.wav'),
  }
}

const audioByGeometry = {
  Box: 'XIAO QUAN',
  Sphere: 'Podeserdesligado',
  TorusKnot: 'Mexa',
  Torus: 'Miss Tacacá',
  Cone: 'Diaz',
  Dodecahedron: 'ótimoKaráter',
}

const playAudio = (audio, type) => {
  if (!audio) return
  if (type === 'hover' && isMobile) return

  audio.currentTime = 0
  audio.volume = 1
  audio.loop = false
  audio.play().catch((e) => console.warn('failed to play audio', e))
}

const playByName = (artistName, type) => {
  if (!artistName) return
  if (!audios[artistName]) return
  playAudio(audios[artistName][type], type)
}

const playByGeometryName = (geometryName, type) => {
  playByName(audioByGeometry[geometryName], type)
}

export {
  audios,
  playByName,
  playByGeometryName,
}
